import { Alert, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useEmployee } from '~/data/employee';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';
import { EmployeeDataForm } from '~/scenes/PeopleModule/components/Tabs/BasicTab/components/EmployeeDataForm';
import { EmploymentDataForm } from '~/scenes/PeopleModule/components/Tabs/BasicTab/components/EmploymentDataForm';
import { PeopleModuleBasicDataAccessMode } from '~/scenes/PeopleModule/components/Tabs/BasicTab/data';

import { LimitedEmployeeData } from './components/LimitedEmployeeData';
import { LimitedEmploymentData } from './components/LimitedEmploymentData';
import { useSxStyles } from './useStyles';

type PropsType = {
  accessMode: PeopleModuleBasicDataAccessMode;
};

export const BasicTab = (props: PropsType) => {
  const { accessMode } = props;
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  const { selectedEmployeeId } = useSelectedEmployeeId();
  const {
    employee,
    isLoading: isLoadingEmployee,
    failedToLoad,
    hasData,
  } = useEmployee();

  if (isLoadingEmployee) {
    return (
      <Box sx={sxStyles.loading}>
        <CircularProgress />
      </Box>
    );
  }

  // Ensure correct employee data has been loaded
  const isEmployeeInSync =
    selectedEmployeeId === employee?.empBasicData?.fEmpId;

  if ((!isLoadingEmployee && !hasData) || failedToLoad || !isEmployeeInSync) {
    return <Alert severity={'error'}>{t('errorMessage')}</Alert>;
  }

  switch (accessMode) {
    case PeopleModuleBasicDataAccessMode.Full:
    case PeopleModuleBasicDataAccessMode.ITAdmin:
      return (
        <Box sx={sxStyles.root}>
          <Box sx={sxStyles.employeeData}>
            <EmployeeDataForm />
          </Box>
          <Box sx={sxStyles.employmentData}>
            <EmploymentDataForm />
          </Box>
        </Box>
      );
    case PeopleModuleBasicDataAccessMode.Limited:
    default:
      return (
        <Box sx={sxStyles.root}>
          <Box sx={sxStyles.employeeData}>
            <LimitedEmployeeData employee={employee} />
          </Box>
          <Box sx={sxStyles.employmentData}>
            <LimitedEmploymentData employee={employee} />
          </Box>
        </Box>
      );
  }
};
